import { createApp } from "vue";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import router from "./router.js";

var vuetify = createVuetify({
	components,
	directives,
	icons: { defaultSet: "mdi", aliases, sets: { mdi } },
	theme: {
		defaultTheme: "dark",
		themes: {
			dark: {
				dark: true,
				colors: {
					primary: "#1e88e5",
					secondary: "#7e57c2",
					accent: "#26c6da",
					error: "#ef5350",
					warning: "#ffa726",
					info: "#42a5f5",
					success: "#66bb6a",
				},
			},
		},
	},
});

var app = createApp(App);
app.use(router);
app.use(vuetify);
app.mount("#app");
